"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        var messageHandlers;
        (function (messageHandlers) {
            /**
             * Framework code to process and route messages
             *
             * This handler is where all messages are added to the decission to add
             * the message to the form, message center, or a light box is made here.
             * This contains the routuing logic for the client messages
             *
             * Note - ClientTestWrapper.js adds a diffrent handler for testing
             */
            var clientMessageHandler;
            (function (clientMessageHandler) {
                clientMessageHandler.internalMessageHandlerName = "clientMessageHandler";
                clientMessageHandler.messageCenter = $dyn.messaging.MessageCenterManager;
                /**
                 * try to find the target form for the message
                 * If there is a target form we also update the messages targetForm with the form
                 */
                function hasTargetForm(message) {
                    var messageHasTargetForm = false;
                    // is the message for the message bar and has a form id
                    if (message.formUniqueId) {
                        // is the message for a open form with a message bar
                        var form = $dyn.messaging.FindTargetForm(message.formUniqueId);
                        if (form && form.MessageBar) {
                            messageHasTargetForm = true;
                            message.targetForm = form;
                        }
                    }
                    // if we did not find the host form and we are not waiting
                    // for the interactions to complete (ie the form could be
                    // in a later interaction try and send it to the parent)
                    if (!messageHasTargetForm && $dyn.value($dyn.async.pending) === 0) {
                        var parentForm = $dyn.messaging.FindTargetForm(message.parentFormId);
                        if (parentForm && parentForm.MessageBar) {
                            messageHasTargetForm = true;
                            message.targetForm = parentForm;
                        }
                    }
                    return messageHasTargetForm;
                }
                clientMessageHandler.hasTargetForm = hasTargetForm;
                /**
                 * checks to see if this is a message box message
                 */
                function isMessageBoxMessage(message) {
                    if (message.type !== $dyn.messaging.MessageType.information &&
                        message.type !== $dyn.messaging.MessageType.warning &&
                        message.type !== $dyn.messaging.MessageType.error &&
                        message.type !== $dyn.messaging.MessageType.fieldValidation &&
                        message.type !== $dyn.messaging.MessageType.controlValidation) {
                        return true;
                    }
                    return false;
                }
                clientMessageHandler.isMessageBoxMessage = isMessageBoxMessage;
                /**
                 * Routes the specified message to the proper target.
                 */
                function AddMessageHandlerMessage(message, messageManager) {
                    // if we have a form with a message bar send the message to it
                    // note: the form may not be "Visible" but that is ok.
                    if (this.isMessageBoxMessage(message)) {
                        // this message was logged on the server so don't add duplicate telemetry
                        $dyn.errorMessageBox({ Text: message.text }, true);
                    }
                    else if (this.hasTargetForm(message)) {
                        message.targetForm.MessageBar.AddMessage(message);
                    }
                    else {
                        this.messageCenter.AddMessage(message);
                    }
                    return true;
                }
                clientMessageHandler.AddMessageHandlerMessage = AddMessageHandlerMessage;
                /**
                 * Routes the specified messages to the proper target.
                 */
                function AddMessages(messages, messageManager) {
                    var messageBarMessages = {};
                    var messageCenterMessages = [];
                    var messageBoxMessages = [];
                    var delayedMessages = [];
                    var deleteMessages = [];
                    var messageBarMessageCount = 0;
                    var ariaMessageString = "";
                    var ariaMessage = "";
                    // Process Messages
                    // tslint:disable-next-line: prefer-for-of
                    for (var i = 0; i < messages.length; i++) {
                        // if we have a target form add it to the message bar
                        var message = messages[i];
                        if (this.isMessageBoxMessage(message)) {
                            messageBoxMessages.push(messages[i]);
                        }
                        else if (message.deleteMessage) {
                            deleteMessages.push(message);
                        }
                        else if (this.hasTargetForm(message)) {
                            messageBarMessageCount++;
                            // if the target form id already has an group add to it
                            if (messageBarMessages[message.formUniqueId]) {
                                messageBarMessages[message.formUniqueId].push(messages[i]);
                            }
                            else {
                                // create a new group and add the message
                                messageBarMessages[message.formUniqueId] = [];
                                messageBarMessages[message.formUniqueId].push(messages[i]);
                            }
                            ariaMessageString = $dyn.messaging.getMessageBarAriaLabel(messages[i].type) + " " + messages[i].text;
                        }
                        else {
                            // else it goes to message center or if there is a formUniqueId
                            // the form might not be loaded yet (i.e. there was a message on init)
                            // check for either Id. the form id will be "" when the host form is close on the
                            // same interaction that logged the messages. So we need to check the parent id too
                            if ((message.formUniqueId || message.parentFormId) && $dyn.value($dyn.async.pending) > 0) {
                                delayedMessages.push(messages[i]);
                            }
                            else {
                                messageCenterMessages.push(messages[i]);
                            }
                        }
                    }
                    if (messageBarMessages) {
                        if (messageBarMessageCount === 1) {
                            ariaMessage = ariaMessageString;
                        }
                        else {
                            ariaMessage = $dyn.label("MessageAlert");
                        }
                        // tslint:disable-next-line: forin
                        for (var formId in messageBarMessages) {
                            // get the form and add the messages to the message bar
                            var form = messageBarMessages[formId][0].targetForm;
                            form.MessageBar.AddMessages(messageBarMessages[formId]);
                        }
                    }
                    if (messageCenterMessages && messageCenterMessages.length > 0) {
                        this.messageCenter.AddMessages(messageCenterMessages);
                        ariaMessage = ariaMessage + " " + $dyn.label("MessageCenterNotificationAria") + " " + messageCenterMessages.length;
                    }
                    if (messageBoxMessages && messageBoxMessages.length > 0) {
                        // only handle this case if 1 message exists in the light box
                        if (messageBoxMessages.length === 1) {
                            // we are looking for a very specific message , if found then grab the message center and also put in light box
                            if (messageBoxMessages[0].type === $dyn.messaging.MessageType.itemDoesNotExist || messageBoxMessages[0].type === $dyn.messaging.MessageType.itemNotOpened) {
                                // tslint:disable-next-line: forin
                                for (var iMessage in messageCenterMessages) {
                                    // get the form and add the messages to the message bar
                                    messageBoxMessages.push(messageCenterMessages[iMessage]);
                                }
                            }
                        }
                        $dyn.errorMessageBox(messageBoxMessages, true);
                    }
                    // Delete messages
                    if (deleteMessages.length > 0) {
                        $(document.body).trigger("removeMessages", [deleteMessages]);
                        $dyn.messaging.MessageCenterManager.RemoveMessages(deleteMessages);
                    }
                    if (delayedMessages.length > 0) {
                        $.when($dyn.deferred.onTrue(function () {
                            return $dyn.value($dyn.async.pending) === 0;
                        })).done(function () {
                            $dyn.messaging.messageHandlers.clientMessageHandler.AddMessages(delayedMessages, messageManager);
                        });
                    }
                    // update the AriaAlertBar (used by screen readers)
                    $dyn.shell.addAriaAlertMessage(ariaMessage);
                    return true;
                }
                clientMessageHandler.AddMessages = AddMessages;
                /**
                 * Removes the specified messages from the proper target.
                 */
                function RemoveMessageHandlerMessage(messageId, messageManager) {
                    var form = $dyn.messaging.FindTargetForm(messageManager.currentFormId);
                    if (form && form.MessageBar) {
                        form.MessageBar.RemoveMessage(messageId);
                    }
                    else {
                        this.messageCenter.RemoveMessage(messageId);
                    }
                }
                clientMessageHandler.RemoveMessageHandlerMessage = RemoveMessageHandlerMessage;
                /**
                 * Clear the messages.
                 */
                function ClearMessages(messageManager) {
                    // fire event for all the forms to clear their message bar
                    $(document.body).trigger("clearMessageBarMessages");
                    this.messageCenter.ClearMessages();
                    return true;
                }
                clientMessageHandler.ClearMessages = ClearMessages;
            })(clientMessageHandler = messageHandlers.clientMessageHandler || (messageHandlers.clientMessageHandler = {}));
        })(messageHandlers = messaging.messageHandlers || (messaging.messageHandlers = {}));
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageHandlers.js.map
